import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styles from './SingleMessage.scss';
import { getErrorMessage } from '~/components/messages/messages.constants';

const findMessage = (messages, forType) => messages.find((message) => message.type === forType);

export const SingleMessage = ({ forType, errorMessages = [], children = null }) => {
  const message = findMessage(errorMessages, forType);
  if (message) {
    const { title, description } = { ...getErrorMessage(message.type) };
    return (
      <div className={styles.SingleMessage}>
        <p className={styles.Title}>{title}</p>
        <p className={styles.Description}>{description}</p>
        {children}
      </div>
    );
  }
  return null;
};

export const mapStateToProps = ({
  messages: {
    app: { errorMessages },
  },
}) => ({ errorMessages });

export const ConnectedSingleMessage = connect(mapStateToProps)(SingleMessage);

SingleMessage.propTypes = {
  forType: PropTypes.string.isRequired,
  errorMessages: PropTypes.arrayOf(PropTypes.shape({})),
  children: PropTypes.node,
};
